import classnames from 'classnames/bind'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'

// Components
import Shell from '../Shell'
import CollectionIcon from '../CollectionIcon'
import { ArrowRightIcon } from '../Icons'

// Methods
import { helpCollectionPath } from '../../methods'

// Types
import type { HelpCollectionItem } from '@/api/fetchHelpArticle'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

type Props = {
  collections: HelpCollectionItem[]
  countryCode: string
  countryQuery?: string
}

const HelpHome = ({ collections, countryCode, countryQuery }: Props) => {
  const { t } = useTranslation()

  return (
    <Shell isHome countryCode={countryCode} countryQuery={countryQuery}>
      {collections.length === 0 ? (
        <p className={cx('help-empty')}>{t('Help_Center_Empty')}</p>
      ) : (
        <>
          <h2 className={cx('help-section-title')}>{t('Help_Center_Browse')}</h2>
          <ul className={cx('help-collection-grid')}>
            {collections.map((collection) => (
              <li key={collection.id}>
                <Link className={cx('help-collection-card')} href={helpCollectionPath(collection.id, countryQuery)}>
                  <span className={cx('help-collection-card__head')}>
                    <span className={cx('help-collection-card__badge')}>
                      <CollectionIcon src={collection.iconUrl} size={28} />
                    </span>
                    <span className={cx('help-collection-card__name')}>{collection.name}</span>
                  </span>
                  {collection.description && <span className={cx('help-collection-card__desc')}>{collection.description}</span>}
                  <span className={cx('help-collection-card__footer')}>
                    <span>{t('Help_Center_Article_Count', { count: collection.articleCount })}</span>
                    <span className={cx('help-collection-card__arrow')}>
                      <ArrowRightIcon />
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </Shell>
  )
}

export default HelpHome
